export default __webpack_public_path__ + "static/media/anti-ageing.08c34e59.JPG";